import { Row } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const PermissoesStyles = createGlobalStyle`
  .ant-collapse-header {
    color: #fff !important;
    font-weight: bold !important;
    font-size: 14px !important;
    background-color: #A6A6A5;
    line-height: 19px;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    background: #fff !important;
    padding: 16px !important;
  }

  .ant-collapse > .ant-collapse-item {
    border-bottom: none;
  }

  .padding:not(:last-child) {
    .ant-collapse-item {
      padding-bottom: 10px;
      transition: padding-bottom 300ms;
    }

    .ant-collapse-item-active {
      padding-bottom: 0;
      transition: padding-bottom 300ms;
    }
  }

  .padding:last-child {
    .ant-collapse-content-active {
      border-bottom: 1px solid #D9D9D9;
    }
  }
`;

export const LabelCheckbox = styled.span`
  color: #4f4f4f !important;
`;

export const Grupo = styled(Row)`
  border: 1px solid #d9d9d9;
  border-bottom: 0px;
`;

export const SubGrupo = styled(Row)`
  .paddingSubGrupo:not(:last-child) {
    padding-bottom: 32px;
  }
`;

export const Title = styled.span`
  font-weight: 600;
  color: #4f4f4f;
`;
